import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import InvoiceGenerator from './components/demounit';
import CreditGenerator from './components/credit';
import InvoiceList from './components/InvoiceList';
import Login from './components/login';
import DebitGenerator from './components/debit';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
         <Route path="/" element={<Login />} />
        <Route path="/invoice" element={<InvoiceGenerator />} />  
         <Route path="/credit" element={<CreditGenerator />} />                 
        <Route path="/list" element={<InvoiceList />} />    
         <Route path="/debit" element={<DebitGenerator />} />  
      </Routes>
    </BrowserRouter>
  );
};

export default App;